import LoginSso from './LoginSso'

export default LoginSso
